export default "__VITE_ASSET__BXK_hI0h__"